export default {"src":"/_next/static/media/arrow-left.ff4ed8df.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};